<div #textContainer class="bbit-inner-html" [innerHTML]="html()" [ngClass]="{ 'line-clamp-3': isCollapsed() }"></div>
@if (showReadMore()) {
  <button (click)="toggle()" class="mt-8 text-gray-500 hover:text-black text-sm">
    {{ isCollapsed() ? ({ key: 'showMore' } | i18n) : ({ key: 'showLess' } | i18n) }}...
  </button>
}
